import { render, staticRenderFns } from "./DemoShowBlock.vue?vue&type=template&id=392bb962&scoped=true"
import script from "./DemoShowBlock.vue?vue&type=script&lang=ts"
export * from "./DemoShowBlock.vue?vue&type=script&lang=ts"
import style0 from "./DemoShowBlock.vue?vue&type=style&index=0&id=392bb962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bb962",
  null
  
)

export default component.exports